export const NETHONE_SCRIPT_URL =
  'https://d354c9v5bptm0r.cloudfront.net/s/490090/dimension.js'

export const NETHONE_ATTEMPT_REFERENCE_COOKIE_NAME =
  'BM_Nethone_Attempt_Reference'
export const NETHONE_ATTEMPT_REFERENCE_COOKIE_MAX_AGE = 60 * 60 * 24
